import i18n from '@/i18n'
import SiteRender from './core/components/render/siteRender'
import Index from './index.vue'
import Editor from './editor'
import CrmMicroSite from './crm'
import OnboardingMicroSitePreviewer from '../adminNew/companyAdmin/onboardingManagement/microSite/previewer'
import SatisfactionSurveyMicroSitePreviewer from '../adminNew/companyAdmin/satisfactionSurveyManagement/microSite/previewer'
import PostApplicantMicroSitePreviewer from '../adminNew/companyAdmin/postApplicantManagement/microSite/previewer'
import JobApplicationMicroSitePreviewer from '../adminNew/companyAdmin/jobApplicationManagement/microSite/previewer'

const routes = [
  {
    name: 'microSiteAdmin',
    path: '/microsite-admin/:siteId/:device(mobile|pc)/:language(en|zh-cn|tc)/:type(crm|onboarding|satisfactionSurvey|postApplicant|jobApplication)?/:pagePath*',
    component: Editor,
    meta: {
      title: ''
    }
  },
  {
    name: 'microSiteOnboardingAdmin',
    path: '/microsite-admin/:siteId/:device(mobile|pc)/:language(en|zh-cn|tc)/:type(onboarding)/:pagePath*',
    component: Editor,
    meta: {
      title: ''
    }
  },
  {
    name: 'previewCrmMicroSite',
    path: '/microsite/crm/:siteId/:pagePath*',
    component: CrmMicroSite,
    meta: {
      title: '',
      noAuth: true
    }
  },
  {
    name: 'previewOnboardingMicroSite',
    path: '/v-admin/onboarding-management/micro-site/detail/:siteId/:pagePath*',
    component: OnboardingMicroSitePreviewer,
    meta: {
      title: ''
    }
  },
  {
    name: 'previewSatisfactionSurveyMicroSite',
    path: '/v-admin/satisfaction-survey-management/micro-site/detail/:siteId/:pagePath*',
    component: SatisfactionSurveyMicroSitePreviewer,
    meta: {
      title: '',
      isQuestionnaire: true
    }
  },
  {
    name: 'previewPostApplicantSurveyMicroSite',
    path: '/v-admin/post-applicant-management/micro-site/detail/:siteId/:pagePath*',
    component: PostApplicantMicroSitePreviewer,
    meta: {
      title: '',
      isQuestionnaire: true
    }
  },
  {
    name: 'previewJobApplicationMicroSite',
    path: '/v-admin/job-application-management/micro-site/detail/:siteId/:pagePath*',
    component: JobApplicationMicroSitePreviewer,
    meta: {
      title: '',
      isQuestionnaire: true
    }
  }
]

if (process.env.NODE_ENV !== 'production') {
  // only for develop and test
  routes[0].path = '/microsite-admin/:siteId/:device(mobile|pc)/:language(en|zh-cn|tc)/:type(crm|onboarding|local|satisfactionSurvey|postApplicant|jobApplication)?/:pagePath*'
  routes.push({
    name: 'microSiteTest',
    path: '/microsite-test/:siteId/:device(mobile|pc)/:language(en|zh-cn|tc)/:type(crm|onboarding|local|satisfactionSurvey|postApplicant|jobApplication)?/:pagePath*',
    component: SiteRender,
    meta: {
      title: i18n.t(''),
      noAuth: true
    }
  })
}

export default {
  path: '',
  component: Index,
  meta: {
    title: ''
  },
  children: routes
}
